import React, { useState } from 'react';

const ORDERS = [
  { orderId: 'ORD-001', customerId: 'C-204', product: 'Laptop Pro 15', qty: 2, status: 'Delivered' },
  { orderId: 'ORD-002', customerId: 'C-107', product: 'Wireless Mouse', qty: 5, status: 'Pending' },
  { orderId: 'ORD-003', customerId: 'C-341', product: 'USB-C Hub', qty: 1, status: 'Delivered' },
  { orderId: 'ORD-004', customerId: 'C-204', product: 'Monitor 27"', qty: 1, status: 'Returned' },
  { orderId: 'ORD-005', customerId: 'C-512', product: 'Laptop Pro 15', qty: 1, status: 'Delivered' },
  { orderId: 'ORD-006', customerId: 'C-107', product: 'Mechanical Keyboard', qty: 2, status: 'Delivered' },
  { orderId: 'ORD-007', customerId: 'C-341', product: 'Laptop Pro 15', qty: 3, status: 'Pending' },
  { orderId: 'ORD-008', customerId: 'C-512', product: 'USB-C Hub', qty: 4, status: 'Delivered' },
  { orderId: 'ORD-009', customerId: 'C-788', product: 'Monitor 27"', qty: 2, status: 'Delivered' },
  { orderId: 'ORD-010', customerId: 'C-204', product: 'Wireless Mouse', qty: 3, status: 'Delivered' },
];

const CUSTOMERS = [
  { customerId: 'C-107', name: 'Priya Nair', tier: 'Gold', region: 'South' },
  { customerId: 'C-204', name: 'Rohan Mehta', tier: 'Platinum', region: 'West' },
  { customerId: 'C-341', name: 'Sneha Kapoor', tier: 'Silver', region: 'North' },
  { customerId: 'C-512', name: 'Arjun Das', tier: 'Gold', region: 'East' },
  { customerId: 'C-788', name: 'Kavita Rao', tier: 'Silver', region: 'South' },
];

const PRICES = { 'Laptop Pro 15': 85000, 'Monitor 27"': 32000, 'Mechanical Keyboard': 8500, 'Wireless Mouse': 2200, 'USB-C Hub': 3500 };

// Cross-reference reasoning:
// Q1: Which customer (name) has the highest total delivered revenue?
//   Rohan Mehta (C-204): ORD-001 Laptop 2×85000=170000, ORD-010 Mouse 3×2200=6600 (ORD-004 Returned skip) = 176600
//   Priya Nair (C-107): ORD-002 Pending skip, ORD-006 Keyboard 2×8500=17000 = 17000
//   Sneha Kapoor (C-341): ORD-003 Hub 1×3500=3500, ORD-007 Pending skip = 3500
//   Arjun Das (C-512): ORD-005 Laptop 1×85000=85000, ORD-008 Hub 4×3500=14000 = 99000
//   Kavita Rao (C-788): ORD-009 Monitor 2×32000=64000 = 64000
// Answer: Rohan Mehta — 176600

// Q2: How many TOTAL units of "Laptop Pro 15" are in Pending status?
//   ORD-007: qty 3, Pending → 3 units
// Answer: 3

// Q3: Which tier has the highest total delivered order count (number of orders, not units)?
//   Gold (C-107, C-512): C-107 delivered=ORD-006, C-512 delivered=ORD-005,ORD-008 → 3 orders
//   Platinum (C-204): ORD-001,ORD-010 delivered → 2 orders
//   Silver (C-341,C-788): ORD-003,ORD-009 delivered → 2 orders
// Answer: Gold

const EXPECTED = { topCustomer: 'Rohan Mehta', pendingLaptops: '3', topTier: 'Gold' };

export default function C16_CrossReference({ onComplete }) {
  const [activeTable, setActiveTable] = useState('orders');
  const [answers, setAnswers] = useState({ topCustomer: '', pendingLaptops: '', topTier: '' });
  const [submitted, setSubmitted] = useState(false);
  const [interactions, setInteractions] = useState(0);
  const [errors, setErrors] = useState(0);

  const track = () => setInteractions(n => n + 1);

  const handleSubmit = () => {
    if (!answers.topCustomer.trim() || !answers.pendingLaptops.trim() || !answers.topTier.trim()) {
      setErrors(e => e + 1);
      return;
    }
    setSubmitted(true);
    const norm = s => s.trim().toLowerCase();
    const r1 = norm(answers.topCustomer) === norm(EXPECTED.topCustomer);
    const r2 = answers.pendingLaptops.trim() === EXPECTED.pendingLaptops;
    const r3 = norm(answers.topTier) === norm(EXPECTED.topTier);
    const correct = [r1, r2, r3].filter(Boolean).length;
    onComplete({
      score: Math.round((correct / 3) * 100),
      details: {
        topCustomer: { expected: EXPECTED.topCustomer, got: answers.topCustomer.trim(), pass: r1 },
        pendingLaptops: { expected: EXPECTED.pendingLaptops, got: answers.pendingLaptops.trim(), pass: r2 },
        topTier: { expected: EXPECTED.topTier, got: answers.topTier.trim(), pass: r3 },
      },
      passed: correct === 3,
      interactionCount: interactions,
      errorAttempts: errors,
    });
  };

  const ch = (e) => { setAnswers(a => ({ ...a, [e.target.name]: e.target.value })); track(); };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-tabs-bar">
        {['orders', 'customers', 'prices'].map(t => (
          <button key={t} className={`ab-tab ${activeTable === t ? 'ab-tab-active' : ''}`}
            onClick={() => { setActiveTable(t); track(); }} disabled={submitted}>
            {t === 'orders' ? '📦 Orders' : t === 'customers' ? '👤 Customers' : '💰 Price List'}
          </button>
        ))}
      </div>

      <div className="ab-tab-panel">
        {activeTable === 'orders' && (
          <div className="ab-table-wrap"><table className="ab-table">
            <thead><tr><th>Order ID</th><th>Customer ID</th><th>Product</th><th>Qty</th><th>Status</th></tr></thead>
            <tbody>
              {ORDERS.map(o => (
                <tr key={o.orderId} className={o.status === 'Returned' ? 'ab-row-bottom' : o.status === 'Pending' ? 'ab-row-highlight' : ''}>
                  <td>{o.orderId}</td><td>{o.customerId}</td><td><strong>{o.product}</strong></td>
                  <td>{o.qty}</td>
                  <td><span className={`ab-badge ${o.status === 'Delivered' ? 'ab-badge-green' : o.status === 'Pending' ? 'ab-badge-orange' : 'ab-badge-red'}`}>{o.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
        {activeTable === 'customers' && (
          <div className="ab-table-wrap"><table className="ab-table">
            <thead><tr><th>Customer ID</th><th>Name</th><th>Tier</th><th>Region</th></tr></thead>
            <tbody>
              {CUSTOMERS.map(c => (
                <tr key={c.customerId}>
                  <td>{c.customerId}</td><td><strong>{c.name}</strong></td>
                  <td><span className={`ab-badge ${c.tier === 'Platinum' ? 'ab-badge-blue' : c.tier === 'Gold' ? 'ab-badge-orange' : 'ab-badge-gray'}`}>{c.tier}</span></td>
                  <td>{c.region}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
        {activeTable === 'prices' && (
          <div className="ab-table-wrap"><table className="ab-table">
            <thead><tr><th>Product</th><th>Unit Price (Rs)</th></tr></thead>
            <tbody>
              {Object.entries(PRICES).map(([p, v]) => (
                <tr key={p}><td><strong>{p}</strong></td><td>Rs {v.toLocaleString('en-IN')}</td></tr>
              ))}
            </tbody>
          </table></div>
        )}
      </div>

      <div className="ab-reasoning-questions">
        <div className="ab-reasoning-q">
          <label className="ab-label">Q1. Which customer (full name) generated the highest total DELIVERED revenue across all their orders?</label>
          <input name="topCustomer" value={answers.topCustomer} onChange={ch}
            className="ab-input ab-answer-input" placeholder="Full name" disabled={submitted} />
        </div>
        <div className="ab-reasoning-q">
          <label className="ab-label">Q2. How many total units of "Laptop Pro 15" are currently in Pending status?</label>
          <input name="pendingLaptops" value={answers.pendingLaptops} onChange={ch}
            className="ab-input ab-answer-input" placeholder="Number" disabled={submitted} />
        </div>
        <div className="ab-reasoning-q">
          <label className="ab-label">Q3. Which customer tier (Gold / Silver / Platinum) has the most DELIVERED orders (count of orders, not units)?</label>
          <input name="topTier" value={answers.topTier} onChange={ch}
            className="ab-input ab-answer-input" placeholder="Tier name" disabled={submitted} />
        </div>
      </div>

      {!submitted
        ? <button className="ab-action-btn" onClick={handleSubmit}>Submit All Answers</button>
        : <div className="ab-submitted-badge">✓ Submitted — Evaluating...</div>
      }
    </div>
  );
}
